export default {"src":"https://cdn.jetlend.ru/_next/static/media/icon--arrow-left--circle.29b1a5c7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};